module.exports = __webpack_public_path__ + "img/luka_claudio_rave_unscharf_ocular.002b53ca.jpg";